// extracted by mini-css-extract-plugin
module.exports = {"root":"seller-grid_root__2t3wR"};